"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainSchema = void 0;
const __1 = require("../");
// export const DOMAIN_REGEX =
//   /^(?=.{4,64}$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*(?:[a-zA-Z0-9])$/g;
// export const DomainSchema = z.string().min(1).max(253).regex(DOMAIN_REGEX, 'Invalid domain');
exports.DomainSchema = __1.ShortStringSchema;
//# sourceMappingURL=domain.js.map